module.exports = __webpack_public_path__ + "img/d5d17b9.svg";